var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 200,
    viewBox: "0 0 1440 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5315",
    "data-name": "Rectangle 5315",
    width: 1440,
    height: 200,
    transform: "translate(0 -153)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg-waves",
    transform: "translate(0 153)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M14.461-9.856Q230.586-30.827,309.543-52.846C388.5-74.866,445.375-48.115,540-21.717S856.828-32.5,921.066-52.846s121.747-28.739,165.676-14.37,54.836,23.844,126.356,0q71.518-23.844,226.9,14.37V73.135H0V-9.856Z",
    transform: "translate(0 -10)",
    fill: "rgba(255,255,255,0.6)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M0-34.193Q71.688-57.276,180-45.734C288.313-34.193,358.039,1.548,479.988-7.263s275.906-63.3,376.4-50.884S1101.73,18.4,1193.984-7.263C1275.335-29.9,1339.32-66.88,1410.8-45.919q9.579,2.81,29.2,11.726v653.9H0Z",
    transform: "translate(0 10.018)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M0-57.667q105.7-34.873,195.051,6.847C284.4-9.1,271.462,20.4,453.313,16.838S827.782-80.483,987.992-88.443s232.444,72.545,324.02,37.622q91.575-34.923,185.638-14.043V57.188H0Z",
    transform: "translate(-24.65 -34.053)",
    fill: "rgba(255,255,255,0.3)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWaves);
export default __webpack_public_path__ + "static/media/bg-waves.ccd9054bb7cbe970ec1e01add42d92e5.svg";
export { ForwardRef as ReactComponent };